import React, { Component } from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import { GetEnglishOrArabic } from "../../";

import { Radio } from "antd";

import OptionChoice from "./OptionChoice";

export class OptionGroup extends Component {
  state = { radioValue: null };
  setRadioValue = (value) => {
    this.setState({ radioValue: value });
  };

  render() {
    const {
      t,
      option,
      selectedOverall,
      selectedOptions,
      config,
      productUsedComponents,
      productQuantity,
      editedProduct,
      group,
      allOptions,
      onOpenConditionalModal,
    } = this.props;

    const radioValue = this.state.radioValue;
    const hasChildren = (choice) =>
      (this.props.allOptions || []).some(
        (opt) =>
          opt.condition_parent_option === choice.option &&
          opt.condition_parent === choice.id,
      );
    const choices = option.choices.map((choice, index) => {
      return (
        <OptionChoice
          key={`${group?.id || ""} ${index}-${choice.id}-${option.id}`}
          choice={choice}
          addOptionToProduct={this.props.addOptionToProduct}
          option={option}
          selectedOverall={selectedOverall}
          setRadioValue={this.setRadioValue}
          selected={
            selectedOptions[choice.id] ? selectedOptions[choice.id].quantity : 0
          }
          productUsedComponents={productUsedComponents}
          productQuantity={productQuantity}
          editedProduct={editedProduct}
          groupID={group?.id}
          hasChildren={hasChildren(choice)}
          onOpenConditionalModal={this.props.onOpenConditionalModal}
        />
      );
    });
    const required = option.is_required ? t("Required") : t("Optional");

    const description = GetEnglishOrArabic(
      option.description,
      option.ar_description,
      config.language,
    );

    return (
      <>
        <div
          className="mb-3 mt-2 mx-1 border-top border-bottom p-3"
          style={{ fontSize: "1rem" }}
        >
          <h4
            style={{
              fontSize: "1rem",
              marginBottom: description ? "6px" : "4px",
            }}
          >
            {t(
              `${
                group
                  ? GetEnglishOrArabic(
                      group.name,
                      group.ar_name,
                      config.language,
                    ) + " - "
                  : ""
              } ${t("Choose")} ${GetEnglishOrArabic(
                option.name,
                option.ar_name,
                config.language,
              )}`,
            )}
          </h4>

          {description && (
            <p
              style={{
                fontSize: "0.85rem",
                color: "#6c757d",
                marginBottom: "6px",
                lineHeight: "1.4",
                fontStyle: "italic",
              }}
            >
              {description}
            </p>
          )}

          <span className="text-muted" style={{ fontSize: "0.8rem" }}>
            {option.is_required && <span style={{ color: "red" }}>* </span>}
            {required} &mdash; {t("min")} : {option.minimum} {t("max")} :
            {option.maximum}
          </span>
        </div>
        {choices?.length <= 0 && (
          <div className="w-100 m-1 px-3 py-1">
            {t("There is no Active Choices")}
          </div>
        )}
        <div className="w-100">{choices}</div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({ config: state.config });

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withNamespaces()(OptionGroup));
